var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c(
      "div",
      { staticClass: "main-content" },
      [
        _c(
          "search-item",
          {
            ref: "searchItem",
            attrs: {
              "config-module": "92111",
              "expand-adv": true,
              "show-simple": false,
              "custom-search-items": _vm.customSearchItems
            },
            on: { advSearchItemCallBack: _vm.queryHandler }
          },
          [
            _c(
              "div",
              { attrs: { slot: "operations" }, slot: "operations" },
              [
                _vm.batchGenerateCarFormShow &&
                _vm.source === "useCarApplicationFormTab"
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.$emit("batchGenerateCarFormHandle")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("CargoMsg.Cargo_BatchGenerateVehicleOrder")
                          )
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          { staticStyle: { flex: "1 1 0", "min-height": "350px" } },
          [
            _c("cargo-ag-grid-wrapper", {
              staticStyle: { height: "100%" },
              attrs: {
                "config-module": "202506072",
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData,
                "show-selected-color": false,
                "check-sub-record": false
              },
              on: {
                gridReady: function(params) {
                  _vm.gridApi = params.api
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c("cargo-pagination", {
              attrs: {
                "config-module": "202506072",
                total: _vm.filter.total,
                page: _vm.filter.pageNum,
                limit: _vm.filter.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.filter, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.filter, "pageSize", $event)
                },
                pagination: _vm.fetchDataByPage
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }